// PRE RMA CSB — Lecture (SANS vérification de signature) du contenu d'un jeton de session, côté navigateur.
// Sert uniquement à l'affichage : le serveur reste seul juge (il vérifie la signature à chaque requête). Objectif : le rôle et le CSB
// affichés par l'écran sont TOUJOURS ceux du jeton réellement envoyé au serveur (plus de menus Admin avec un jeton « Responsable CSB »).
export interface DonneesJeton { role: string | null; csbId: string | null }

export function lireJeton(token: string | null | undefined): DonneesJeton | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const bin = atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4));
    const o = JSON.parse(new TextDecoder().decode(Uint8Array.from(bin, (c) => c.charCodeAt(0))));
    if (!o || typeof o !== 'object') return null;
    return { role: typeof o.role === 'string' ? o.role : null, csbId: typeof o.csbId === 'string' && o.csbId ? o.csbId : null };
  } catch {
    return null;
  }
}

/** Profil restreint (STOCK / AGENT) lu dans le jeton ; null = compte standard (Admin, Responsable CSB) : aucun verrou de modules. */
export function lireProfilJeton(token: string | null | undefined): string | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const bin = atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4));
    const o = JSON.parse(new TextDecoder().decode(Uint8Array.from(bin, (c) => c.charCodeAt(0))));
    return o && typeof o.profil === 'string' && o.profil ? o.profil : null;
  } catch {
    return null;
  }
}
